'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState, useRef } from 'react';
import { Search, X, Filter } from 'lucide-react';
import { useRouter } from 'next/navigation';
interface SearchBarProps {
  initialQuery?: string;
  onSearch?: (query: string) => void;
  onClose?: () => void;
  onFilterClick?: () => void;
  showFilterIcon?: boolean;
}
export default function SearchBar(t0) {
  const $ = _c(34);
  const {
    initialQuery: t1,
    onSearch,
    onClose,
    onFilterClick,
    showFilterIcon: t2
  } = t0;
  const initialQuery = t1 === undefined ? "" : t1;
  const showFilterIcon = t2 === undefined ? false : t2;
  const router = useRouter();
  const [searchText, setSearchText] = useState(initialQuery);
  const inputRef = useRef(null);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setSearchText("");
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const handleClear = t3;
  let t4;
  if ($[1] !== onClose || $[2] !== onSearch || $[3] !== router) {
    t4 = query => {
      if (onSearch) {
        onSearch(query);
      } else {
        router.push(`/search/${encodeURIComponent(query)}`);
      }
      if (onClose) {
        onClose();
      }
    };
    $[1] = onClose;
    $[2] = onSearch;
    $[3] = router;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleSearch = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e => {
      setSearchText(e.target.value);
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleInputChange = t5;
  let t6;
  if ($[6] !== handleSearch || $[7] !== searchText) {
    t6 = e_0 => {
      if (e_0.key === "Enter" && searchText.trim()) {
        e_0.preventDefault();
        handleSearch(searchText);
      }
    };
    $[6] = handleSearch;
    $[7] = searchText;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleKeyDown = t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute left-4 pointer-events-none z-10"><Search className="text-[#000000]" size={20} /></div>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== handleKeyDown || $[11] !== searchText) {
    t8 = <input ref={inputRef} type="text" value={searchText} onChange={handleInputChange} onKeyDown={handleKeyDown} placeholder="Search..." className="w-full pl-12 pr-12 py-3 bg-[#ffffff] text-[#000000] text-16-English-400 border border-DCDCDC" autoComplete="off" />;
    $[10] = handleKeyDown;
    $[11] = searchText;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== searchText) {
    t9 = searchText && <button onClick={handleClear} className="absolute right-2 p-1  rounded transition-colors z-10" aria-label="Clear search"><X className="text-[#000000]" size={20} /></button>;
    $[13] = searchText;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <div className="relative flex-1"><div className="relative flex items-center">{t7}{t8}{t9}</div></div>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== handleSearch || $[19] !== searchText) {
    t11 = () => searchText.trim() && handleSearch(searchText);
    $[18] = handleSearch;
    $[19] = searchText;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== searchText) {
    t12 = searchText.trim();
    $[21] = searchText;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = !t12;
  const t14 = `bg-[#012061] w-full md:max-w-[165px] md:mx-auto max-w-[80px] text-FFFFFF md:px-2 md:py-3 px-8 py-3 flex justify-center text-16-tamil-400 transition-colors ${!searchText.trim() ? "opacity-50 cursor-not-allowed" : "hover:bg-[#012061]/90"}`;
  let t15;
  if ($[23] !== t11 || $[24] !== t13 || $[25] !== t14) {
    t15 = <button onClick={t11} disabled={t13} className={t14}>தேடு</button>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== onFilterClick || $[28] !== showFilterIcon) {
    t16 = showFilterIcon && <button onClick={onFilterClick} className="bg-[#FFFFFF] w-[48px] h-[48px] ml-2 rounded-full border-2 border-[#012061] flex items-center justify-center hover:bg-[#f0f4ff] transition-colors"><Filter className="text-[#012061]" size={20} /></button>;
    $[27] = onFilterClick;
    $[28] = showFilterIcon;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t10 || $[31] !== t15 || $[32] !== t16) {
    t17 = <div className="relative p-4"><div className="flex items-center gap-0 h-cover w-full max-w-[865px]">{t10}{t15}{t16}</div></div>;
    $[30] = t10;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
}